module.exports = {"id":"219180","name":"Dani Calvo","rating":"72","photo":"./data/images/photos/3/219180.png","club":{"name":"CD Numancia","logo":"./data/images/clubs/CDNumancia.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DaniCalvo0.json
// module id = 910
// module chunks = 0